import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { BookingStatusModel } from "./BookingStatusModel";

export class BookingStatusFindResultModel extends BaseFindResult {

    public getDataItem(i: number): BookingStatusModel {
        let o: BookingStatusModel = Object.assign(new BookingStatusModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): BookingStatusModel[] {

        let d: BookingStatusModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: BookingStatusModel = Object.assign(new BookingStatusModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
